// Compteur des favoris dans l'en-tête. Relu après chaque clic, pour suivre
// un ajout ou un retrait fait sur la page sans recharger.
(function () {
  function updateWishBadges() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('lp_wishlist') || '[]'); } catch (e) {}
    var n = list.length;
    document.querySelectorAll('.lp-wish-nav-btn').forEach(function (btn) {
      var badge = btn.querySelector('.lp-wish-nav-badge');
      if (!badge) return;
      if (n > 0) badge.textContent = n > 9 ? '9+' : n;
      badge.style.display = n > 0 ? 'flex' : 'none';
      btn.classList.toggle('has-items', n > 0);
    });
  }

  document.addEventListener('click', function () { setTimeout(updateWishBadges, 0); });
  window.addEventListener('storage', function (e) { if (e.key === 'lp_wishlist') updateWishBadges(); });
})();
